module.exports = __webpack_public_path__ + "images/CC_Multi Choice Media Placeholders_5.svg";